import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const EVENTCATEGORY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.EventCategory.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const EVENTCATEGORY_CONFIG = {
  entityName: 'EventCategory',
  localizationKey: 'Controlling::Entity.EventCategory',
  fields: EVENTCATEGORY_FIELDS,
  permission: 'General.EventCategories',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: undefined,
};
